import { render } from "./StoreButtonWrite.vue?vue&type=template&id=2976edac&scoped=true"
import script from "./StoreButtonWrite.vue?vue&type=script&lang=js"
export * from "./StoreButtonWrite.vue?vue&type=script&lang=js"

import "./StoreButtonWrite.vue?vue&type=style&index=0&id=2976edac&scoped=true&lang=css"

import exportComponent from "E:\\GoWorkSpace2\\src\\storedisk\\storedisk\\storedisk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2976edac"]])

export default __exports__